var map = {
	"./flag1.png": 39,
	"./flag10.png": 807,
	"./flag2.png": 308,
	"./flag3.png": 821,
	"./flag4.png": 154,
	"./flag5.png": 915,
	"./flag6.png": 43,
	"./flag7.png": 137,
	"./flag8.png": 982,
	"./flag9.png": 79,
	"./flag_gray.png": 164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 123;